import * as THREE from "three";

/**
 * Procedural-fallback texture for a prop/container (W19). A canvas-backed
 * "{label}" tile tinted from a hash of the slug — used until the authored
 * PNG at `world/props/<slug>/idle.png` (or `.../containers/.../closed.png`)
 * loads.
 *
 * Extracted to its own module so tests can stub it without a canvas 2D
 * context (jsdom doesn't implement `getContext("2d")`).
 */
export function makeProceduralPropTexture(slug: string, label: string): THREE.CanvasTexture {
  const w = 128;
  const h = 192;
  const canvas = document.createElement("canvas");
  canvas.width = w;
  canvas.height = h;
  const ctx = canvas.getContext("2d")!;

  const hue = [...slug].reduce((a, c) => a + c.charCodeAt(0), 0) % 360;
  ctx.fillStyle = `hsl(${hue}, 45%, 40%)`;
  ctx.fillRect(w * 0.15, h * 0.25, w * 0.7, h * 0.7);

  ctx.strokeStyle = `hsl(${hue}, 55%, 25%)`;
  ctx.lineWidth = 3;
  ctx.strokeRect(w * 0.15, h * 0.25, w * 0.7, h * 0.7);

  ctx.fillStyle = "white";
  ctx.font = "bold 28px monospace";
  ctx.textAlign = "center";
  ctx.textBaseline = "middle";
  ctx.fillText(label.charAt(0).toUpperCase(), w / 2, h / 2);

  const tex = new THREE.CanvasTexture(canvas);
  // Canvas pixels are sRGB — tag them or the renderer gamma-lifts on output.
  tex.colorSpace = THREE.SRGBColorSpace;
  tex.magFilter = THREE.NearestFilter;
  tex.minFilter = THREE.LinearFilter;
  return tex;
}

export function authoredImageToTexture(img: HTMLImageElement): THREE.CanvasTexture {
  const w = 128;
  const h = 192;
  const canvas = document.createElement("canvas");
  canvas.width = w;
  canvas.height = h;
  const ctx = canvas.getContext("2d")!;
  ctx.drawImage(img, 0, 0, w, h);
  const tex = new THREE.CanvasTexture(canvas);
  // Authored PNGs are sRGB — tag them or the renderer gamma-lifts on output.
  tex.colorSpace = THREE.SRGBColorSpace;
  tex.magFilter = THREE.NearestFilter;
  tex.minFilter = THREE.LinearFilter;
  return tex;
}
